import {Component, EventEmitter, Output, OnInit} from '@angular/core';
import {ConfigService} from '../core/services/config/config.service';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
    @Output() sideNavAction = new EventEmitter();
    public groupSalesKeyName = 'hasGroupSalesAccess';
    public showGroupSales = false;

    public showCustomerMenuKeyName = 'customerMenuHidden';
    public showCustomerMenu = false;

    // Cross-buyer portfolio view (RLP-4274) — role-gated nav entry.
    public portfolioKeyName = 'hasPortfolioAccess';
    public showPortfolio = false;

    constructor(private configService: ConfigService) {
    }

    ngOnInit() {
        this.getGroupSalesAndCustomerMenuAccess();
    }

    public toggleSideNav(): void {
        this.sideNavAction.emit();
    }

    public isScreenEnabled(screenId: string): boolean {
        return this.configService.isScreenEnabled(screenId);
    }

    public getGroupSalesAndCustomerMenuAccess(): boolean {
        let value: any = {};
        try {
            value = JSON.parse(localStorage.getItem('userConfig')) || {};
        } catch {
            value = {};
        }
        this.showGroupSales = (value[this.groupSalesKeyName] === false) && !this.configService.isGroupSalesOnlyRole();
        this.showCustomerMenu = (value[this.showCustomerMenuKeyName] === true);
        this.showPortfolio = (value[this.portfolioKeyName] === true);
        return this.showGroupSales;
    }

}
